<div class="page-container unified">
  <div class="page-not-found-content-container">
    <div class="page-not-found-decoration-container col-12 col-md-6 col-lg-7">
      <div class="content">
        <img
          src="{{ './assets/rightbridge-logo.png' }}"
          id="Polygon-1"
          class="unified-logo"
          alt="RightBRIDGE Logo"
        />
        <mat-icon id="Polygon-2" class="app-button-icon" svgIcon="aw_icon" />
        <mat-icon id="Polygon-3" class="app-button-icon" svgIcon="pp_icon" />
        <mat-icon id="Polygon-4" class="app-button-icon" svgIcon="iw_icon" />
        <mat-icon id="Polygon-5" class="app-button-icon" svgIcon="lw_icon" />
        <mat-icon id="Polygon-6" class="app-button-icon" svgIcon="cm_icon" />

        <app-background-decoration />
      </div>
    </div>

    <div class="display-content col-6">
      <h1>403 - Page Not Allowed</h1>
      <h3>
        The content you have requested is not allowed for the current user.
        Please reach out to your administrator if this user should have access
        to this content.
      </h3>
      <app-redirect-timer [duration]="15" />
    </div>
  </div>
</div>
